import { IAppState } from '../../../AppModulesWrapper';

import { IServicePeriod } from '../../types/reducers/publishTerms';

export const selectActiveCalltrackingPeriod = (state: IAppState): IServicePeriod | null => {
  const {
    calltracking: { period },
  } = state.servicePickerWidget;

  return period || null;
};
